import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { HomePage } from './pages/HomePage';
import { FinancialPage } from './pages/FinancialPage';
import { TextToolsPage } from './pages/TextToolsPage';
import { FunPage } from './pages/FunPage';
import { DeveloperPage } from './pages/DeveloperPage';
// Financial Tools
import { MortgageCalculator } from './pages/financial/MortgageCalculator';
import { TipCalculator } from './pages/financial/TipCalculator';
import { EmiCalculator } from './pages/financial/EmiCalculator';
// Text Tools
import { WordCounter } from './pages/text-tools/WordCounter';
import { CaseConverter } from './pages/text-tools/CaseConverter';
import { EmailExtractor } from './pages/text-tools/EmailExtractor';
// Fun Tools
import { SecretSanta } from './pages/fun/SecretSanta';
import { SecretSantaGame } from './pages/fun/SecretSantaGame';
import { SecretSantaReveal } from './pages/fun/SecretSantaReveal';
import { RandomPicker } from './pages/fun/RandomPicker';
// Developer Tools
import { PasswordGenerator } from './pages/developer/PasswordGenerator';
import { JsonFormatter } from './pages/developer/JsonFormatter';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen flex flex-col bg-background text-foreground" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-1" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />

            {/* Category Pages */}
            <Route path="/financial" element={<FinancialPage data-id="element-8" />} data-id="element-7" />
            <Route path="/text-tools" element={<TextToolsPage data-id="element-10" />} data-id="element-9" />
            <Route path="/fun" element={<FunPage data-id="element-12" />} data-id="element-11" />
            <Route path="/developer" element={<DeveloperPage data-id="element-14" />} data-id="element-13" />

            {/* Financial Tools */}
            <Route path="/financial/mortgage-calculator" element={<MortgageCalculator data-id="element-16" />} data-id="element-15" />
            <Route path="/financial/emi-calculator" element={<EmiCalculator data-id="element-18" />} data-id="element-17" />
            <Route path="/financial/tip-calculator" element={<TipCalculator data-id="element-20" />} data-id="element-19" />
            <Route path="/financial/home-emi-calculator" element={<EmiCalculator data-id="element-22" />} data-id="element-21" />
            <Route path="/financial/vehicle-emi-calculator" element={<EmiCalculator data-id="element-24" />} data-id="element-23" />

            {/* Text Tools */}
            <Route path="/text-tools/word-counter" element={<WordCounter data-id="element-26" />} data-id="element-25" />
            <Route path="/text-tools/case-converter" element={<CaseConverter data-id="element-28" />} data-id="element-27" />
            <Route path="/text-tools/email-extractor" element={<EmailExtractor data-id="element-30" />} data-id="element-29" />

            {/* Fun Tools */}
            <Route path="/fun/secret-santa" element={<SecretSanta data-id="element-32" />} data-id="element-31" />
            <Route path="/fun/secret-santa/:gameId" element={<SecretSantaGame data-id="element-34" />} data-id="element-33" />
            <Route path="/fun/secret-santa/:gameId/reveal" element={<SecretSantaReveal data-id="element-36" />} data-id="element-35" />
            <Route path="/fun/random-picker" element={<RandomPicker data-id="element-38" />} data-id="element-37" />

            {/* Developer Tools */}
            <Route path="/developer/password-generator" element={<PasswordGenerator data-id="element-40" />} data-id="element-39" />
            <Route path="/developer/json-formatter" element={<JsonFormatter data-id="element-42" />} data-id="element-41" />
          </Routes>
        </main>
        <Footer data-id="element-43" />
      </div>
    </BrowserRouter>;
}